import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import KanbanBoard from "@/components/operations/work-orders/kanban/kanban-board";

export const Route = createFileRoute(
  "/_authenticated/operations/work-orders/_list/",
)({
  component: WorkOrdersKanbanPage,
});

function WorkOrdersKanbanPage() {
  return (
<RouteGuardPermissions
      permissions={[{ module: "work_orders", actions: ["read"] }]}>
      
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <KanbanBoard />
    </div>
  
    </RouteGuardPermissions>
  );
}
